import { QuestionnaireAnswerDeafultValue } from 'constants/questionnaires';
import { MantaCareUser } from 'context/UserContext/types';
import { Request } from 'hooks/user/useRequests/types';
import { QuestionnaireObject } from 'types/questionnaire';

export const MAP_ASSIGNMENT_STATUS = {
    ASSIGNED: 'assinged',
    IN_PROGRESS: 'in_progress',
    NOT_ASSIGNED: 'not_assigned',
    CONTACTED: 'contacted'
};

export const getMapAssignmentStatus = (user: MantaCareUser, requests: Request[] = [], questionnaireData?: QuestionnaireObject) => {
    if (user?.assignedRegions?.length) {
        return { status: MAP_ASSIGNMENT_STATUS.ASSIGNED };
    }

    // @ts-expect-error
    const contactRequest = requests.find(item => item.payload.map === 'other' && item.payload.contact);
    if (contactRequest) {
        return { status: MAP_ASSIGNMENT_STATUS.CONTACTED, data: contactRequest };
    }

    // @ts-expect-error
    const otherTypeRequest = requests.find(item => item.payload.map === 'other');
    if (otherTypeRequest) {
        return { status: MAP_ASSIGNMENT_STATUS.IN_PROGRESS, data: otherTypeRequest };
    }

    const isMapQuestionnaireSubmitted =
        questionnaireData?.cancerSubType && questionnaireData.cancerSubType !== QuestionnaireAnswerDeafultValue;
    if (isMapQuestionnaireSubmitted) {
        return { status: MAP_ASSIGNMENT_STATUS.IN_PROGRESS, data: { payload: { description: questionnaireData.cancerSubType } } };
    }

    return { status: MAP_ASSIGNMENT_STATUS.NOT_ASSIGNED };
};
